module.exports = __webpack_public_path__ + "static/assets/7223cc265f7989f555578860af82cf6e.png";